"use client";
import { motion } from "motion/react";

interface Amenity {
  AmenitiesName: string;
}

interface AmenitiesSectionProps {
  amenities: Amenity[];
}

export default function AmenitiesSection({ amenities }: AmenitiesSectionProps) {
  if (!amenities || amenities.length === 0) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
      {amenities.map((amenity, index) => (
        <motion.div
          key={index}
          className="flex items-center gap-4 bg-white rounded-xl px-8 py-6 shadow-sm hover:shadow-lg transition-shadow"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.05 }}
          viewport={{ once: true }}
        >
          <div className="w-2 h-2 bg-[#B42025] rounded-full flex-shrink-0" />
          <span className="text-gray-700">{amenity?.AmenitiesName}</span>
        </motion.div>
      ))}
    </div>
  );
}
